import React from "react";
import i18n from "../../i18n";
import contryData from "../../constants/country.json";
import { forgotPassword } from "../../models/login";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { baseUrl } from "../../constants/global";

const codeData = [...contryData];

export class NewForgotPassword extends React.Component {
    constructor() {
        super();
        this.state = {
            input: {},
            errors: {},
            sending: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.sendForgetPasswordEmail = this.sendForgetPasswordEmail.bind(this);
    }

    handleChange(event) {
        let input = this.state.input;
        input[event.target.name] = event.target.value;
        this.setState({ input });
    }

    async sendForgetPasswordEmail() {
        this.setState({ sending: true });
        const response = await forgotPassword({ userId: this.state.input.userId });
        if (response.success) {
            this.setState({ sending: false });
            swal(i18n.t("success"), response.message, "success", {
                buttons: false,
                timer: 10000,
            })
                .then((value) => { })
                .catch((response) => {
                    this.setState({ sending: false });
                    swal("Failed", response.message, "error");
                });
        } else {
            this.setState({ sending: false });
            swal("Failed", response.message, "error");
        }
    }

    render() {
        const { userId, password, rememberMe, isLoading, errors } = this.state;

        return (
            <div className="vh-100 d-flex">
                {/* Left Side - Login Form */}
                <div className="col-lg-6 d-flex align-items-center justify-content-center bg-white">
                    <div className="w-100" style={{ maxWidth: '400px', padding: '2rem' }}>

                        {/* Logo
                        <div className="mb-3">
                            <div className="d-flex align-items-center">
                                <div className="logo-section">
                                    <Link to="/home" className="logo">
                                        <img
                                            src="/assets/images/l-1.svg"
                                            alt="Company Logo"
                                            style={{ width: '100%', height: '100%' }}
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div> */}

                        {/* Welcome Header */}
                        <div className="mb-3">
                            <h2 className="fw-bold text-dark mb-2" style={{ fontSize: '2rem' }}>
                                {i18n.t("forget_password")}

                            </h2>
                        </div>

                        {/* Login Form */}
                        <div>

                            {/* Email Field */}
                            <div className="mb-3">
                                <label className="form-label text-dark fw-medium mb-1">
                                    {i18n.t("username_or_email")}
                                </label>
                                <input
                                    type="email"
                                    name="userId"
                                    className={`form-control ${errors.userId ? 'is-invalid' : ''}`}
                                    value={userId}
                                    onChange={this.handleChange}
                                    style={{
                                        padding: '12px 16px',
                                        fontSize: '14px',
                                        border: errors.email ? '1px solid #dc3545' : '1px solid #d1d5db',
                                        borderRadius: '8px',
                                        backgroundColor: '#fff'
                                    }}
                                    placeholder={i18n.t("username_or_email")}
                                />
                                {errors.userId && (
                                    <div className="text-danger small mt-1">{errors.userId}</div>
                                )}
                            </div>




                            {/* Sign In Button */}
                            <button
                                onClick={this.sendForgetPasswordEmail}
                                disabled={isLoading}
                                className="btn w-100 text-white fw-medium mb-2"
                                style={{
                                    backgroundColor: '#189397',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    fontSize: '14px'
                                }}
                            >
                                {isLoading &&
                                    i18n.t("sending")}
                                {!isLoading && i18n.t("send")}
                            </button>

                            {/* Sign Up Link */}
                            <div className="text-center mb-3">
                                <span className="text-muted" >
                                    Forget it,{" "} <Link
                                        to="/login"
                                        style={{ color: '#189397', fontSize: '15px' }}
                                    > send me back </Link>
                                </span>
                                <span className="text-muted" >
                                    to the{" "}<Link
                                        to="/login"
                                        style={{ color: '#189397', fontSize: '15px' }}
                                    > sign in</Link>
                                </span>
                            </div>

                            {/* <Link
                                                                  to="/comp-registration"
                                className="btn w-100 fw-medium mb-1"
                                style={{
                                    border: '#d1d5db 1px solid',
                                    color: '#black',
                                    borderRadius: '8px',
                                    fontSize: '14px'
                                }}
                            >

                                <span style={{
                                    color: '#black',

                                }}>    {i18n.t("register_bidder")}</span>

                            </Link> */}

                            {/* <Link
                                to="/client-registration"
                                className="btn w-100 fw-medium mb-4"
                                style={{
                                    border: '#d1d5db 1px solid',
                                    color: '#black',
                                    borderRadius: '8px',
                                    fontSize: '14px'
                                }}
                            >

                                <span style={{
                                    color: '#black',

                                }}> {i18n.t("register_client")}</span>

                            </Link> */}


                            {/* Google Sign In
                            <button
                                onClick={this.handleGoogleLogin}
                                className="btn w-100 d-flex align-items-center justify-content-center "
                                style={{
                                    border: '1px solid #d1d5db',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    backgroundColor: '#fff',
                                    fontSize: '14px'
                                }}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" className="me-2">
                                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                                </svg>
                                Sign in with Google
                            </button> */}

                        </div>
                    </div>
                </div>

                <div
                    className="col-lg-6 d-none d-lg-block position-relative"
                    style={{
                        backgroundImage: `linear-gradient(135deg, rgba(24,147,151,0.5) 0%, rgba(189,197,50,0.5) 100%),url('/assets/images/auth/banner-1.jpeg')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                    {/* Background Pattern */}
                    {/* <div className="position-absolute w-100 h-100">
         
                        <div className="position-absolute" style={{ top: '15%', left: '10%' }}>
                            <i className="fa fa-cogs text-white opacity-25" style={{ fontSize: '2rem' }}></i>
                        </div>
                        <div className="position-absolute" style={{ top: '25%', right: '15%' }}>
                            <i className="fa fa-wrench text-white opacity-25" style={{ fontSize: '1.5rem' }}></i>
                        </div>
                        <div className="position-absolute" style={{ top: '35%', left: '20%' }}>
                            <i className="fa fa-cog text-white opacity-25" style={{ fontSize: '1.8rem' }}></i>
                        </div>
                        <div className="position-absolute" style={{ bottom: '30%', right: '10%' }}>
                            <i className="fas fa-envelope text-white opacity-25" style={{ fontSize: '1.6rem' }}></i>
                        </div>
                        <div className="position-absolute" style={{ top: '45%', right: '25%' }}>
                            <i className="fa fa-car text-white opacity-25" style={{ fontSize: '1.4rem' }}></i>
                        </div>

                       
                        {[...Array(15)].map((_, i) => (
                            <div
                                key={i}
                                className="position-absolute text-white opacity-15"
                                style={{
                                    top: `${Math.random() * 80 + 10}%`,
                                    left: `${Math.random() * 80 + 10}%`,
                                    fontSize: '1rem'
                                }}
                            >
                                {['○', , '◯', '◆'][Math.floor(Math.random() * 4)]}
                            </div>
                        ))}
                    </div> */}
                </div>

                {/* FontAwesome CDN */}
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
                />
            </div>
        );
    }
}
